var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 19.9987,
    r: 14.6667,
    fill: "#FEF7C3",
    stroke: "#FEFBE8",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 17.9962V20.6629M19.9998 23.3296H20.0064M19.0766 14.5907L13.5934 24.0618C13.2892 24.5871 13.1372 24.8498 13.1596 25.0654C13.1793 25.2534 13.2778 25.4243 13.4307 25.5355C13.606 25.6629 13.9095 25.6629 14.5165 25.6629H25.483C26.09 25.6629 26.3935 25.6629 26.5688 25.5355C26.7217 25.4243 26.8203 25.2534 26.8399 25.0654C26.8623 24.8498 26.7103 24.5871 26.4061 24.0618L20.9229 14.5907C20.6198 14.0673 20.4683 13.8056 20.2706 13.7177C20.0982 13.641 19.9013 13.641 19.7289 13.7177C19.5312 13.8056 19.3797 14.0673 19.0766 14.5907Z",
    stroke: "#DC6803",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningMessage);
export default __webpack_public_path__ + "static/media/warning-message.0d9efb4d.svg";
export { ForwardRef as ReactComponent };